import { type FC } from 'react';
import { useDispatch } from 'react-redux';
import { Button } from 'react-bootstrap';

import ModalWindow from '@editor2/components/ModalWindow';
import { updateElement } from '@editor2/reducers/editor/editorSlice';

interface Props {
	isShown: boolean;
	elementId: string;
	courseId: number;
	onHide: () => void;
}

const RemoveDataModal: FC<Props> = (props) => {
	const { isShown, elementId, courseId, onHide } = props;

	const dispatch = useDispatch();

	const onRemoveDataClick = () => {
		dispatch(
			updateElement({
				elementId,
				courseId,
				data: null,
				total_count: null,
				data_type: null,
				data_group_by: null,
				choice_ordering: 'fixed',
				source_dataset_index: null,
				contextual_info: null
			})
		);
		onHide();
	};

	const title = <div>Remove data sets</div>;

	const footer = (
		<Button variant="danger" size="sm" onClick={onRemoveDataClick}>
			Yes, Remove Data Sets
		</Button>
	);

	return (
		<ModalWindow isShown={isShown} onHide={onHide} title={title} footer={footer}>
			<div>Are you sure you want to remove the external data sets?</div>
		</ModalWindow>
	);
};

export default RemoveDataModal;
